import { ChevronDown } from "lucide-react";

export type FaqEntry = { q: string; a: string | string[] };

/**
 * FAQ oparte na natywnych <details>/<summary> — treść odpowiedzi jest
 * obecna w HTML od razu po załadowaniu strony (widoczna dla robotów),
 * a zwinięcie realizuje przeglądarka, bez display:none w React.
 */
export function FaqDetails({ items, className = "" }: { items: FaqEntry[]; className?: string }) {
  return (
    <div className={`border-t border-steel ${className}`}>
      {items.map((item) => {
        const paragraphs = Array.isArray(item.a) ? item.a : [item.a];
        return (
          <details key={item.q} className="group border-b border-steel">
            <summary className="flex min-h-11 cursor-pointer list-none items-center justify-between gap-4 py-6 text-left text-base font-medium text-ink transition-colors hover:text-coral-text md:text-lg [&::-webkit-details-marker]:hidden">
              <span>{item.q}</span>
              <ChevronDown className="size-4 shrink-0 transition-transform duration-200 group-open:rotate-180" />
            </summary>
            <div className="space-y-4 pb-6 text-base leading-relaxed text-ink/80">
              {paragraphs.map((p) => (
                <p key={p}>{p}</p>
              ))}
            </div>
          </details>
        );
      })}
    </div>
  );
}
